import "../Footer/Footer.css";
import React, { useEffect, useState } from "react";
import packageImg from "../../images/package.jpg";
import paymentsImg from "../../images/payments.png";
import quickImg from "../../images/quick.jpg";
import { fetchBrands } from "../../api/brands.api";

const VISIBLE_COUNT = 5;

const FooterExtras = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startIndex, setStartIndex] = useState(0);

  const handleNext = () => {
    if (startIndex + VISIBLE_COUNT < brands.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const visibleBrands = brands.slice(
    startIndex,
    startIndex + VISIBLE_COUNT
  );

  useEffect(() => {
    let mounted = true;

    fetchBrands()
      .then((data) => {
        if (!mounted) return;
        setBrands(Array.isArray(data) ? data.slice(0, 7) : []);
      })
      .catch(() => {
        if (mounted) setBrands([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <footer className="footer-wrapper">
      {/* ================= WHY CHOOSE US ================= */}
      <div className="chooseUs">
        <h3>WHY SHOULD YOU CHOOSE US?</h3>

        <div className="chooseCards">
          <div className="chooseSubCards">
            <img className="chooseImg" src={quickImg} alt="Quick delivery" />
            <h4>QUICK DELIVERY</h4>
            <p>Pickups for shipping will happen on Monday and will be dispatched within 72 hours</p>
          </div>

          <div className="chooseSubCards">
            <img
              className="chooseImg choosepayment"
              src={paymentsImg}
              alt="Secure payments"
            />
            <h4>EASY PAYMENTS</h4>
            <p>All payments are processed securely and instantly.</p>
          </div>

          <div className="chooseSubCards">
            <img className="chooseImg" src={packageImg} alt="Packaging" />
            <h4>SPECIAL PACKAGING</h4>
            <p>Our packaging is designed to protect collectibles.</p>
          </div>
        </div>
      </div>

      {/* ================= BRANDS STRIP ================= */}
     
    </footer>
  );
};

export default FooterExtras;
